import React, { useContext } from "react";
import { Switch, Tooltip } from "antd";
import { BulbOutlined, BulbFilled } from "@ant-design/icons";
import { ThemeContext } from "../context/ThemeContext";
import "./DarkModeToggle.css";

const DarkModeToggle = () => {
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);

  return (
    <Tooltip title={darkMode ? "Switch to light mode" : "Switch to dark mode"}>
      <div className="dark-mode-toggle">
        <Switch
          checked={darkMode}
          onChange={toggleDarkMode}
          checkedChildren={<BulbOutlined />}
          unCheckedChildren={<BulbFilled />}
        />
      </div>
    </Tooltip>
  );
};

export default DarkModeToggle;
